import React from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "../components/Layout";
import Login from "../components/Login";
import Faltas from "../components/Faltas";
import ListadoFaltas from "../components/FaltasListado";
import useAuth from "../hooks/useAuth";
import RequireAuth from "../components/RequireAuth";
import PersistLogin from "../components/PersistLogin";
import Home from "../components/Home";
import { useLocation } from "react-router-dom";
import PerfilUsuario from "../components/PerfilUsuario";

import Clientes from "../pages/Clientes";
import ProductoServicio from "../pages/ProductoServicio";
import PagosFacturas from "../pages/PagosFacturas";
import Facturas from "../pages/Facturas";
import Reportes from "../pages/Reportes";
import Configuracion from "../pages/Configuracion";

const ROLES = {
  User: 2001,
  Editor: 1984,
  Admin: 5150,
};
export function MyRoutes() {
  const location = useLocation();
  const { auth } = useAuth();
  // console.log(auth);
  localStorage.setItem("usuario", JSON.stringify(auth.user));

  if (["/login", "/register", "/forgot-password"].includes(location.pathname)) {
    document.body.classList.add("login-page");
  } else {
    document.body.classList.remove("login-page");
  }

  return (
    <>
      <Routes>
        {/* public routes */}
        <Route path="login" element={<Login />} />

        <Route element={<PersistLogin />}>
          <Route element={<RequireAuth allowedRoles={[ROLES.User]} />}>
            <Route path="/" element={<Layout Auth={auth} />}>
              <Route index element={<Home Auth={auth}/>} />
              <Route path="/perfil" element={<PerfilUsuario Auth={auth} />} />
              <Route path="faltas">
                <Route index element={<Faltas />} />
                <Route path=":idFalta" element={<Faltas />} />
                <Route path="listado" element={<ListadoFaltas />} />
              </Route>
              <Route path="clientes" element={<Clientes />} />
              <Route path="ProductoServicio" element={<ProductoServicio />} />
              <Route path="pagos" element={<PagosFacturas />} />
              <Route path="facturas" element={<Facturas />} />
              <Route path="Reportes" element={<Reportes />} />
              <Route path="Configuracion" element={<Configuracion />} />
            </Route>
          </Route>
        </Route>
    
      </Routes>
      
    </>
  );
}
